import { render, staticRenderFns } from "./TabsTable.vue?vue&type=template&id=664dca5f&scoped=true"
import script from "./TabsTable.vue?vue&type=script&lang=js"
export * from "./TabsTable.vue?vue&type=script&lang=js"
import style0 from "./TabsTable.vue?vue&type=style&index=0&id=664dca5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664dca5f",
  null
  
)

export default component.exports